/**
 * Leaflet markerCluster - group close markers
 */
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster/dist/leaflet.markercluster.js';

/**
 * Leaflet extra-markers - custom markers with custom color and
 * fontawesome icons
 */
import 'leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css';
import 'leaflet-extra-markers/dist/js/leaflet.extra-markers.min.js';

/**
 * Leaflet easyprint - plugin for map print, export
 */
import 'leaflet-easyprint/dist/bundle.js';

/**
 * leaflet georaster
 */
//const GeoRasterLayer = require('georaster-layer-for-leaflet');

import AppManager from './managers/AppManager';
AppManager.init();

// TODO
import { show, toggle } from '@siteparts/show-hide-effects';
import { dispatchCustomEvent } from './utils';
import * as eventNames from './customEventStrings';

const appContainer = document.getElementById("appContainer");
const dialects = JSON.parse(appContainer.dataset.dialects);

function getDialectsHtml(parentId) {
	let result = `<ul style="list-style: none">`;
	for (let i in dialects) {
		let dialect = dialects[i];

		if (dialect.parent_id == parentId) {
			result += `<li><h3 id="dialect-${dialect.id}-name" style="position: relative; font-size: 1em; margin-top: 1em; margin-bottom: 1em; transition: background-color 1s">`;

			if (dialect.description != "") {
				result += `
    <button type="button" data-toggle="collapse" data-target="#dialect-${dialect.id}-description" aria-expanded="false" aria-controls="#dialect-${dialect.id}-description" style="background: none; border: none; cursor: pointer; font-size: 1em; position: absolute; top: -0.15em; left: -1.3em;">
        <i class="fas fa-chevron-right" style="color: #ff914d;"></i>
    </button>`;
			}

			result += `
    <span style="color: #777; font-weight: normal">${dialect.level_name}: ${dialect.level != 'region' ? dialect.code : ''}</span>
    ${dialect.name}
</h3>`;

			if (dialect.description != "") {
				result += `
<div style="display: none; background-color: #eee; padding: .5em 1em" id="dialect-${dialect.id}-description">${dialect.description}</div>
`;
			}

			if (dialect.children_count > 0) {
				result += getDialectsHtml(dialect.id);
			}
			result += `</li>`
		}
	}
	return result + `</ul>`;
}

let sidePanel = document.querySelector('[ref="component-side-panel"]');
let dialectPanel = document.createElement("div");
dialectPanel.classList.add("sidepanel", "js-dialect-panel");
dialectPanel.style.backgroundColor = "white";
dialectPanel.style.color = "#333";
dialectPanel.style.paddingLeft = "3em";
dialectPanel.style.display = "grid";
dialectPanel.style.boxShadow = "0 3px 14px rgba(0,0,0,.7)";
dialectPanel.style.zIndex = 501000;
dialectPanel.innerHTML = `<div class="sidepanel__header">
    <h2>Nárečia</h2>
    <span class="close" aria-label="close"><i class="fas fa-times"></i></span>
</div>
<div style="max-width: 85ch; overflow-y: scroll">
` + getDialectsHtml(null) + `</div>`;

dialectPanel.querySelector(".close").addEventListener("click", () => {
	dialectPanel.classList.remove("active");
});

let buttons = dialectPanel.querySelectorAll('[data-toggle="collapse"]');
buttons.forEach(button => {
	button.addEventListener("click", () => {
		toggle(dialectPanel.querySelector(button.dataset.target));
		button.querySelector("i").classList.toggle("fa-chevron-right");
		button.querySelector("i").classList.toggle("fa-chevron-down");
		button.setAttribute("aria-expanded", button.getAttribute("aria-expanded") == "true" ? "false" : "true");
	})
});

sidePanel.after(dialectPanel);

document.addEventListener("click", e => {
	if (e.target.classList.contains("js-show-dialect")) {
		e.preventDefault();

		dialectPanel.querySelectorAll('[aria-expanded="true"]').forEach(button => {
			button.click();
		});

		dialectPanel.classList.add("active");

		const dialectId = e.target.dataset.dialectId;
		const nameElement = dialectPanel.querySelector(`#dialect-${dialectId}-name`);
		const button = nameElement.querySelector('[data-toggle="collapse"]');

		if (button) {
			button.click();
		}

		nameElement.scrollIntoView();

		nameElement.style.backgroundColor = "#DEFEE2";
		setTimeout(() => {
			nameElement.style.removeProperty("background-color");
		}, 3000);
	} else if (e.target.classList.contains('js-open-modal')) {
		dispatchCustomEvent(eventNames.OPEN_MODAL, e.target, true, e.target.dataset);
	}
});
